"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "collebeato": {
    "0f40b3ab": [{
      "hkey": "a864dda5",
      "slug": "collebeato",
      "name": "Collebeato",
      "primary": true,
      "skipSearch": false
    }],
    "campianelli": [{
      "hkey": "a864dda5",
      "slug": "collebeato",
      "name": "Collebeato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0bef72cd": [{
      "hkey": "8b9e18d1",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "villa-di-sopra": [{
      "hkey": "8b9e18d1",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "collebeato"
    }],
    "8a6dbde1": [{
      "hkey": "8b9e18d1",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "villa-di-sotto": [{
      "hkey": "8b9e18d1",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "collebeato"
    }]
  }
};
exports["default"] = _default;